import "./index.css";

import React, { Component } from "react";
import { Link } from "react-router-dom";

/* Components */
import Page from "../../../components/Page";
import NavigationBar from "../../../components/NavigationBar";
import WebFooter from "../../../components/WebFooter";

class AboutUs extends Component {

    componentDidMount() {
        document.title = "About Us - J4Crew Professional Yacht Crew Agency";
        return window.scrollTo(0, 0);
    }

    render() {

        return(
            <Page match={this.props.match} hideNavbar={true}>
                <div className="page-intro-linear-container">
                    <NavigationBar { ...this.props } />
                    <div style={{ height: 30 }}></div>
                    <h4>About Us</h4>
                </div>
                <div style={{height: 75}}></div>
                <div className="about-us-team-header-container">
                    <p>Yachting is in our DNA</p>
                </div>
                <div className="about-us-text">
                    <p style={{ textAlign: "center" }}>J4Crew was established in 1999 by Joe Hodgson, appearing on the scene as just4engineers. Today, Jacob runs the business, carrying forward the same values of partnership and trust.</p>
                </div>
                <div className="about-us-text">
                    <p style={{ textAlign: "center" }}>Jacob is a trained Marine Officer with commercial and yachting experience, bringing his own ideas and perspectives to the business.</p>
                </div>
                <div className="about-us-text">
                    <p style={{ textAlign: "center" }}>We have established ourselves as an industry leader and have built long term relationships with our clients and crew. We are committed to maintaining the highest standards and focus on providing quality over quantity.</p>
                </div>
                <div style={{height: 100}}></div>
                <img className="about-us-separator-image" src={require("../../../assets/images/fam.webp")} alt="The J4Crew team" />
                <div style={{height: 100}}></div>
                <div className="about-us-team-member-container">
                    <div className="about-us-team-member-image-container">
                        <img src={require("../../../assets/images/jacob.webp")} alt="Jacob Hodgson" />
                    </div>
                    <div className="about-us-team-member-info-container">
                        <p className="about-us-team-member-name">Jacob Hodgson</p>
                        <p className="about-us-team-member-position">Director and Recruitment Consultant</p>
                        <div className="about-us-text">
                            <p>Jacob is a qualified Deck OOW with both commercial and yachting experience. He joined in 2018 and continues to diligently match clients and crew.</p>
                        </div>
                        <div className="about-us-text">
                            <p>He grew up in both England and the South of France so was exposed to the yachting industry from a young age, holding an OOW ticket and a foundation degree in Marine Operations obtained through the Trinity House cadetship scheme. In his seagoing career he has served as Mate on both offshore vessels and super yachts.</p>
                        </div>
                        <div className="about-us-text">
                            <p>He enjoys his work and very rarely takes a day off! In his spare time he takes a keen interest in all things sports. In particular, football and is a keen footballer himself, playing a few times a week to a competitive standard.</p>
                        </div>
                        <div className="about-us-text">
                            <p>Contact him directly with the following details:</p>
                            <p>Email: <a href="mailto:jacob@j4crew.com" target="_blank" rel="noopener noreferrer">jacob@j4crew.com</a></p>
                            <p>Phone: <a href="https://wa.me/447598382232" target={"_blank"} rel="noopener noreferrer">+44 7598 382 232</a>. (WhatsApp)</p>
                        </div>                        
                        <div className="web-page-home-about-us-cell-row-socials-container">
                            <a href={"https://www.linkedin.com/in/jacob-hodgson-259b8b120/"} target={"_blank"} rel="noopener noreferrer">
                                <img src={require("../../../assets/svgs/linkedin.svg")} alt="" />
                            </a>
                        </div>
                    </div>
                </div>
                <WebFooter />
            </Page>
        );

    }

}

export default AboutUs;